module.exports = __webpack_public_path__ + "static/media/shoes_text.e9f55a4f.png";